import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';

export default function DetailForm({props, read, save, remove, 
    overwriteWarningFlag, overwriteHandleWarning, isNew}: any) {
  
  const [overwriteFlag, setOverwriteFlag] = useState("false");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);

  const { register, handleSubmit, reset, watch, errors, formState  } = useForm();
  
  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;
  
  const onSubmit = (data : any, e: any) => {
    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
    overwriteHandleWarning();
  }
  
  // console.log(errors);
  // {errors}
  return (
      <div>
        <Form id='DetailsFrom' className="mt-3 mb-3" onSubmit={handleSubmit(onSubmit)}>
            
       {/* <input type="text" placeholder="First name" name="First name" ref={register({ required:true, minLength:10 })} />  */}
            {/* <Form  className="mt-3 mb-3">
                <FormGroup row={true}>
                    <Label for="fullName" sm={2}>Name</Label >
                    <Col lg={6} sm={10}>
                        <Input type="text" name="fullName" defaultValue={props.userData?.fullName} readOnly={true} />
                    </Col>
                </FormGroup>
            </Form> */}
            <FormGroup row={true}>
                <Label for="courseTitle" sm={2}>Title</Label >
                <Col lg={6} sm={10}>
                    <Input type="text" name="courseTitle" readOnly={true} defaultValue={props.data?.courseTitle} 
                        innerRef={register({ required: true, minLength:10 })} />
                </Col>
            </FormGroup>
            {/* {
                JSON.stringify(props.data)
            } */}
            
            <Input type="hidden" name="Overwrite" value={overwriteFlag} innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            {/* <FormGroup row={true}>
                <Col sm={12}>
                    {
                        !isNew && (
                            <Button color="danger" size="lg" className="float-left" disabled={props.ui.loading || props.ui.processing} 
                                onClick={toggleRemoveWarning}>
                                <i className="fas fa-trash-alt mr-1"></i>&nbsp;Remove
                            </Button>
                        )
                    }
                    <Button type="submit" color="primary" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("false")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Save
                    </Button>
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup> */}
            <Modal isOpen={overwriteWarningFlag} toggle={overwriteHandleWarning}>
                <ModalHeader toggle={overwriteHandleWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Record you changing is not the latest version. <br/>
                        Please confirm if you want to :- <br/>
                        1. Overwrite. Update latest data with your changes. <br/>
                        2. Reload. Discarding your current changes.<br/>
                        3. Cancel. Remain your changes.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>                 
                    <Button form="DetailsFrom" type="submit" color="warning" size="lg" className="float-right" 
                        disabled={props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("true")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Overwrite
                    </Button>
                    <Button color="danger" size="lg" onClick={handleReloadData}>
                        <i className="fas fa-redo-alt mr-1"></i>&nbsp; Reload
                    </Button>
                    <Button color="secondary" size="lg" onClick={overwriteHandleWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/users" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to User List
                    </RouterNavLink>
                </ModalFooter>
            </Modal> 
        </Form>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </div>
    
  );
}